// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_ztYhC","content":"index_content_WnYI2","more":"index_more_LfM3C","fold":"index_fold_xGles"};